import { render, staticRenderFns } from "./Instructivos.vue?vue&type=template&id=3928d0e4"
import script from "./Instructivos.vue?vue&type=script&lang=js"
export * from "./Instructivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports